import React from "react";
import { Button } from "../../packages/excalidraw";

/**
 * The primary "get this canvas into My Files" affordance, in the top-right row
 * beside Logout / Share — where users look for it — instead of being buried in
 * the ☰ menu one row from Excalidraw's unrelated "Save to..." (local export).
 *
 * Shown only when there is something to save that isn't saved: a signed-in user
 * on a scratch canvas with content. Once the file lives in the cloud, autosave
 * takes over and the title + save-status chips say so, so this button steps
 * aside.
 *
 * Uses the same `Button` primitive as the neighbouring Logout button, so it
 * inherits the identical shape and colour.
 */
export const SaveToCloudButton: React.FC<{ onSelect: () => void }> = ({
  onSelect,
}) => (
  <Button
    className="save-to-cloud-btn"
    data-testid="save-to-cloud-button"
    type="button"
    title="Save this mindmap to My Files"
    onSelect={onSelect}
  >
    Save
  </Button>
);

export default SaveToCloudButton;
